import { IThemeConfig } from '../../core/theme/types';

export default {
  timeText: {
    color: (data: IThemeConfig) => data.color,
  },
};
